/**
 * Algolia Instantsearch with Autocomplete/Suggestions
 *
 */
import { unescape } from 'lodash'
//import moment from 'moment'
import RelativeTime from '@yaireo/relative-time'
import {autocomplete, getAlgoliaResults} from '@algolia/autocomplete-js'
import algoliasearch from 'algoliasearch'
import instantsearch from 'instantsearch.js'

import historyRouter from 'instantsearch.js/es/lib/routers/history'
import {
  connectSearchBox,
  connectSortBy
} from 'instantsearch.js/es/connectors'

import {
  searchBox,
  hierarchicalMenu,
  hits,
  pagination,
  refinementList,
  currentRefinements,
  clearRefinements,
  sortBy,
  configure

} from 'instantsearch.js/es/widgets'

const AlgoliaInstantSearch = ($) => {

  if (!window.Tangible) return
  /*const ajax = window.Tangible.ajax
  const ajaxConfig = window.Tangible.ajaxConfig
  const tangibleSelect = window.Tangible.Select*/

  const tgblCWKFrontend_json = window.atob(tgblCWKFrontend_e)
  const tgblCWKFrontend = jQuery.parseJSON(tgblCWKFrontend_json)
  const LOCALIZED = tgblCWKFrontend.localized

  //console.log(tgblCWKFrontend)

  const facetMapping = {

    // misc
    'cwk_lesson': LOCALIZED.cwk_lesson,
    'cwk_videos': LOCALIZED.cwk_videos,
    'cwk_video': LOCALIZED.cwk_video,
    'clear_refinements': LOCALIZED.clear_refinements,
    'no_refinements': LOCALIZED.no_refinements,


  }

  let INSTANT_SEARCH_INDEX_NAME = tgblCWKFrontend.cwk_tv_algolia_index
  let autocomplete_rendered = false
  const virtualSearchBox = connectSearchBox(() => {})
  const instantSearchRouter = historyRouter() || {}


  //console.log(instantSearchRouter)

  // Return the InstantSearch index UI state.
  function getInstantSearchUiState() {
    const uiState = instantSearchRouter.read()
    return (uiState && uiState[INSTANT_SEARCH_INDEX_NAME]) || {}
  }

  const initialSearchPageState = instantSearchRouter.read()

  // Global object
  window.AlgoliaInstantSearchFunctions = {}

  $(document).ready(function () {
    window.AlgoliaInstantSearchFunctions.constructor()
  })

  window.AlgoliaInstantSearchFunctions = {

    // initialize the code
    constructor: function () {

      //window.PEFavoritesFunctions.saveToFavorites()

      const $_this = this

      const tgbl_instantsearch_container__js= $('.tgbl-instantsearch-container--js')
      if(tgbl_instantsearch_container__js.length) {
        this.algoliaSearch($_this)
        this.toggleStatusVisibility($_this)
        this.switchGridTableButton($_this)
        this.onPopstateCorrection($_this,INSTANT_SEARCH_INDEX_NAME)
      }
    },


    algoliaSearch: function($_this, search_index) {

      const container = $('.tgbl-instantsearch-container--js')
      const user_saved_favorites = container.attr('data-user_saved_favorites')
      const user_id = container.attr('data-user_id') ? container.attr('data-user_id') : 0
      const is_admin = container.attr('data-is_admin') ? container.attr('data-is_admin') : 0

      // if we have replica index from sortby
      INSTANT_SEARCH_INDEX_NAME = search_index != undefined ? search_index : INSTANT_SEARCH_INDEX_NAME

      const algoliaClient = algoliasearch(
        window.atob(tgblCWKFrontend.EAID),
        window.atob(tgblCWKFrontend.EAK)
      )
      const index = algoliaClient.initIndex(INSTANT_SEARCH_INDEX_NAME);

      const searchClient = {
        ...algoliaClient,
        search(requests) {
          const newRequests = requests.map((request) => {
            // Test for empty string and change `analytics` request parameter to `false`
            if(!request.params.query || request.params.query.length === 0) {
              request.params.analytics = false;
            }
            return request;
          })

          return algoliaClient.search(newRequests);
        },
      };

      const search = instantsearch({
        searchClient,
        indexName: INSTANT_SEARCH_INDEX_NAME,
        routing: instantSearchRouter,
      })

      /***************
       *
       * INSTANTSEARCH
       *
       ****************/

      let status_filters = $_this.getStatusFilters($_this)
      let filters = $_this.algoliaSearchFilters($_this, status_filters, user_id, is_admin)
      //console.log('final filters: ', filters)
      //final filters:  (course_users_not_started:991 OR course_users_in_progress:991 OR course_users_completed:991) AND course_users_favorites:991 AND course_users_enrolled:991

      /***************
       CUSTOM SORTBY
       ****************/

        // Create the render function
      const renderSortBy = (renderOptions, isFirstRender) => {

        //console.log(renderOptions)

        const {
          options,
          currentRefinement,
          refine,
          widgetParams,
          // `canRefine` is only available from v4.45.0
          // Use `hasNoResults` in earlier minor versions.
          canRefine,
        } = renderOptions;

        if (isFirstRender) {
          const select = document.createElement('select')

          select.addEventListener('change', event => {
            const search_index = event.target.value
            //renderOptions.instantSearchInstance.helper.state.filters = filters
            refine(event.target.value);
          })
          widgetParams.container.appendChild(select)
        }

        const select = widgetParams.container.querySelector('select')
        select.disabled  = !canRefine

        select.innerHTML = `          
        ${options
          .map(
            option => `
              <option
                value="${option.value}"
                ${option.value === currentRefinement ? 'selected' : ''}
              >
                ${option.label}
              </option>
            `
          ).join('')
        }`
        }

      // Create the custom widget
      const customSortByTitle = connectSortBy(renderSortBy);
      //const customSortByType = connectSortBy(renderSortBy);
      const customSortByDate = connectSortBy(renderSortBy);

      //if(!autocomplete_rendered && tgblCWKFrontend.algolia_show_sortby === 'yes'){
      if(tgblCWKFrontend.algolia_show_sortby === 'yes'){
        search.addWidgets([

          customSortByTitle({
            container: $('#sort-by-name')[0],
            items: [
              { label: LOCALIZED.sort_by_title_asc, value: INSTANT_SEARCH_INDEX_NAME },
              { label: LOCALIZED.sort_by_title_desc, value: 'post_title_desc' },
            ],
          }),
          /*customSortByType({
            container: $('#sort-by-media-type')[0],
            items: [
              { label: LOCALIZED.sort_by_type_asc, value: 'post_type_asc' },
              { label: LOCALIZED.sort_by_type_desc, value: 'post_type_desc' },
            ],
          }),*/
          customSortByDate({
            container: $('#sort-by-date')[0],
            items: [
              { label: LOCALIZED.sort_by_date_asc, value: 'post_date_asc' },
              { label: LOCALIZED.sort_by_date_desc, value: 'post_date_desc' },
            ],
          }),
        ])
      }

      /***************
       ADD AIS WIDGETS
       ****************/

      search.addWidgets([

        configure({
          //filters: filters,
          facetFilters: [
            //'course_users_in_progress:991',
          ]
        }),

        // categories
        refinementList({
          container: '#refinement-list-categories',
          attribute: 'taxonomies.content-category',
          cssClasses: {
            root: 'tgbl-refinement-list tgbl-facet-course-target-role',
            list: [
              'tgbl-refinement-list-list',
              'tgbl-refinement-list-list--subclass',
            ],
            item: 'tgbl-refinement-list-item',
            selectedItem: 'tgbl-refinement-list-selected-item',
            label: 'tgbl-refinement-list-label',
            labelText: 'tgbl-refinement-list-label-text',
            checkbox: 'tgbl-refinement-list-checkbox',
            count: 'tgbl-refinement-list-count',

          },

          transformItems(items) {
            //console.log(items)

            return items.map(item => ({
              ...item,
              label: item.label,
              highlighted: item.label,
            }))
          },
        }),

        // channel
        refinementList({
          container: '#refinement-list-grade-bands',
          attribute: 'taxonomies.channel',
          cssClasses: {
            root: 'tgbl-refinement-list tgbl-facet-course-target-role',
            list: [
              'tgbl-refinement-list-list',
              'tgbl-refinement-list-list--subclass',
            ],
            item: 'tgbl-refinement-list-item',
            selectedItem: 'tgbl-refinement-list-selected-item',
            label: 'tgbl-refinement-list-label',
            labelText: 'tgbl-refinement-list-label-text',
            checkbox: 'tgbl-refinement-list-checkbox',
            count: 'tgbl-refinement-list-count',
          },

          transformItems(items) {
            return items.map(item => ({
              ...item,
              label: item.label,
              highlighted: item.label,
            }))
          },
        }),

        // media type
        refinementList({
          container: '#refinement-list-media-type',
          attribute: 'post_type',
          cssClasses: {
            root: 'tgbl-refinement-list tgbl-facet-course-target-role',
            list: [
              'tgbl-refinement-list-list',
              'tgbl-refinement-list-list--subclass',
            ],
            item: 'tgbl-refinement-list-item',
            selectedItem: 'tgbl-refinement-list-selected-item',
            label: 'tgbl-refinement-list-label',
            labelText: 'tgbl-refinement-list-label-text',
            checkbox: 'tgbl-refinement-list-checkbox',
            count: 'tgbl-refinement-list-count',

          },
          transformItems(items) {
            //console.log(';;;;;; ', items, facetMapping[items[0].value] )
            return items.map(item => ({
              ...item,
              label: facetMapping[item.value],
              highlighted: facetMapping[item.value],
            }))
          },
        }),

        // current refinements
        currentRefinements({
          container: '#current-refinements',
          cssClasses: {
            root: 'tgbl-current-refinements',
            noRefinementRoot: 'tgbl-current-refinements--no-refinement',
            list: [
              'tgbl-current-refinements-list',
              'tgbl-current-refinements-list--subclass',
            ],
            item: 'tgbl-current-refinements-item',
            label: 'tgbl-current-refinements-label',
            category: 'tgbl-current-refinements-category',
            categoryLabel: 'tgbl-current-refinements-category-label',
            delete: 'tgbl-current-refinements-delete',
          },

          transformItems: function (items) {
            //console.log(items)
            $.each(items, function (index, item) {
              //console.log(item)
              $.each(item.refinements, function (index, r) {
                const l = '';
                if(r.label ==='cwk_lesson'){
                  r.label = LOCALIZED.cwk_lesson
                } else if(r.label ==='cwk_video' || r.label ==='cwk_videos'){
                  r.label = LOCALIZED.cwk_videos
                }
              })
            })
            return items
          },
        }),

        // clear refinements
        clearRefinements({
          container: '#clear-refinements',
          cssClasses: {
            root: 'tgbl-clear-refinements',
            disabledButton: 'tgbl-clear-refinements-button-disabled',
            button: [
              'tgbl-clear-refinements-button',
              'tgbl-clear-refinements-button--subclass',
            ],
          },
          templates: {
            resetLabel({hasRefinements}, {html}) {
              return html`
                <span>${hasRefinements ? facetMapping.clear_refinements : facetMapping.no_refinements}</span>`;
            },
          },
        }),

        virtualSearchBox({}),

        hits({
          container: '#hits',
          cssClasses: {
            root: 'tgbl-search-results-wrap',
            list: ['archive-layouts--js', 'archive-layout', 'tt-item-list', 'grid-cols', 'grid-lg-col-4', 'grid-md-col-2'],
            //list: ['archive-layouts--js', 'archive-layout','archive-layout-table'],
            item: ['tt-item', 'tt-item--content'],
            //item: ['MyCustomItem'],
          },
          templates: {
            //item:
            item(hit, {html, components, sendEvent}) {


              const turl = (hit.images.thumbnail != undefined) ? hit.images.thumbnail.url : ''
              const murl = (hit.images.medium.url != undefined) ? hit.images.medium.url : ''
              const lurl = (hit.images.large.url != undefined) ? hit.images.large.url : ''
              const jwppp_video_url = (hit.jwppp_video_url != undefined) ? hit.jwppp_video_url : ''

              // For videos, we first show featured image if exists. If desn't exist we show jwppp_video_url. If nothing of previous, we show nothing 😁
              let image_src = lurl
              //console.log('hit.post_type:: ',hit.post_type , 'hit.jwppp_video_url::: ', hit.jwppp_video_url, 'image_src:: ', image_src)
              if(hit.post_type  === 'cwk_videos' || hit.post_type  === 'cwk_video'){
                image_src = lurl !='' ? lurl : ( jwppp_video_url!= '' ? jwppp_video_url: '' )
              }

              const usf_arr = []
              if (user_saved_favorites != undefined && user_saved_favorites) {
                const usf_obj = jQuery.parseJSON(user_saved_favorites)
                $.each(usf_obj, function (k, v) {
                  usf_arr.push(parseInt(v))
                })
              }
              let saved = 0
              if ($.inArray(hit.post_id, usf_arr) !== -1) {
                saved = 1
              }
              const saved_class = saved ? ' favorite-item saved instantsearch' : ' favorite-item not-saved  instantsearch'
              let not_logged_in_class = ''
              let button_text = ''
              let button_tooltip = ''
              let button_screen_reader_text = ''

              if (user_id) {
                if (saved) {
                  button_text = LOCALIZED.remove_from_fav
                  button_tooltip = LOCALIZED.remove_from_fav_tooltip
                  button_screen_reader_text = LOCALIZED.remove_from_fav_sr
                } else {
                  button_text = LOCALIZED.add_to_fav
                  button_tooltip = LOCALIZED.add_to_fav_tooltip
                  button_screen_reader_text = LOCALIZED.add_to_fav_sr
                }
              } else {
                not_logged_in_class = ' tgbl-must-log-in';
                if (saved) {
                  button_text = LOCALIZED.not_logged_remove_from_fav
                  button_screen_reader_text = LOCALIZED.not_logged_remove_from_fav_sr
                } else {
                  button_text = LOCALIZED.not_logged_add_to_fav
                  button_screen_reader_text = LOCALIZED.not_logged_add_to_fav_sr
                }
              }

              // time ago
              const date_cpec = hit.post_date_cpec
              const relativeTimeSpanish = new RelativeTime({ locale: 'en' })
              new Date(date_cpec).toLocaleDateString()
              const relativeTime = new RelativeTime()
              const time_ago = relativeTime.from(new Date(date_cpec))
              //console.log(hit.objectID, hit.cwk_video_people )

              // CSS classes with the '--js' suffix should be preserved for js functionality!
              return html`                
                  <div class="tt-item__wrapper">
                    <div class="tt-item__image"><img src="${image_src}" /></div> 
                    <div class="tt-item__wrapper__content">
                      
                      <div class="icon__frame">                        
                        <div style=${hit.post_type  === 'cwk_videos' || hit.post_type  === 'cwk_video' ? '' : 'display:none'}>
                          <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon__glyph">
                            <path d="M13.8458 6.98072L3.8423 0.742445C3.58803 0.584859 3.29945 0.501262 3.0054 0.500014C2.71136 0.498766 2.42216 0.579909 2.16672 0.735331C1.91301 0.887325 1.70198 1.10893 1.55549 1.37719C1.40899 1.64545 1.33235 1.95063 1.33351 2.26111V14.7377C1.33235 15.0482 1.40899 15.3533 1.55549 15.6216C1.70198 15.8899 1.91301 16.1115 2.16672 16.2634C2.42207 16.4196 2.7115 16.5012 3.00582 16.5C3.30015 16.4987 3.58896 16.4147 3.84314 16.2563L13.8475 10.0181C14.0967 9.86365 14.3036 9.6421 14.4474 9.37558C14.5911 9.10906 14.6668 8.80692 14.6668 8.49939C14.6668 8.19186 14.5911 7.88972 14.4474 7.6232C14.3036 7.35668 14.0967 7.13513 13.8475 6.98072H13.8458ZM2.99993 14.7377V2.26111L13.0043 8.48516L2.99993 14.7377Z" fill="currentcolor"></path>
                          </svg>
                        </div>

                        <div style=${hit.post_type  === 'cwk_lesson' ? '' : 'display:none'}>
                          <svg width="1em" height="1em" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon__glyph">
                            <path d="M13.0545 0.50001H6.18973C5.86131 0.499112 5.53597 0.560806 5.23258 0.681516C4.92918 0.802225 4.65376 0.97955 4.42228 1.20321L2.06568 3.46561C1.83261 3.68793 1.64784 3.95247 1.5221 4.24389C1.39637 4.5353 1.33216 4.84778 1.3332 5.16321V14.9C1.32651 15.3172 1.49241 15.7199 1.79452 16.0198C2.09663 16.3197 2.5103 16.4924 2.94482 16.5H13.0545C13.4891 16.4924 13.9027 16.3197 14.2048 16.0198C14.5069 15.7199 14.6728 15.3172 14.6661 14.9V2.10001C14.6728 1.68283 14.5069 1.28013 14.2048 0.9802C13.9027 0.680269 13.4891 0.507585 13.0545 0.50001ZM5.49975 2.43121V4.50001H3.34481L5.49975 2.43121ZM2.99982 14.9V6.10001H5.49975C5.94176 6.10001 6.36567 5.93144 6.67822 5.63138C6.99077 5.33132 7.16636 4.92435 7.16636 4.50001V2.10001L12.9945 2.08241C12.9979 2.08769 12.9997 2.0938 12.9995 2.10001L13.0545 14.9H2.99982Z" fill="currentcolor"></path>
                            <path d="M10.5546 7.70001H5.35642C5.13541 7.70001 4.92346 7.78429 4.76718 7.93432C4.6109 8.08435 4.52311 8.28783 4.52311 8.50001C4.52311 8.71218 4.6109 8.91566 4.76718 9.06569C4.92346 9.21572 5.13541 9.3 5.35642 9.3H10.5546C10.7756 9.3 10.9876 9.21572 11.1438 9.06569C11.3001 8.91566 11.3879 8.71218 11.3879 8.50001C11.3879 8.28783 11.3001 8.08435 11.1438 7.93432C10.9876 7.78429 10.7756 7.70001 10.5546 7.70001Z" fill="currentcolor"></path>
                            <path d="M10.5546 10.9H5.35642C5.13541 10.9 4.92346 10.9843 4.76718 11.1343C4.6109 11.2843 4.52311 11.4878 4.52311 11.7C4.52311 11.9122 4.6109 12.1157 4.76718 12.2657C4.92346 12.4157 5.13541 12.5 5.35642 12.5H10.5546C10.7756 12.5 10.9876 12.4157 11.1438 12.2657C11.3001 12.1157 11.3879 11.9122 11.3879 11.7C11.3879 11.4878 11.3001 11.2843 11.1438 11.1343C10.9876 10.9843 10.7756 10.9 10.5546 10.9Z" fill="currentcolor"></path>
                          </svg>
                        </div>
                        
                      </div>
                      
                      <div class="tt-item__content">
                        <!--span > Date: ${hit.post_date_formatted}</span-->
                        <a class="tt-item__title" href="${hit.permalink}" target="_blank" rel="noopener"><span class="tt-item__title__text">${hit.post_title}</span></a>
                        <div class="tt-item__description">${hit.cwk_video_duration}</div>
                        <div class="tt-item__meta tt-item__meta--date">Added ${time_ago}</div>
                        <div
                          class="tgbl-favorite-actions favorite-actions--js  ${not_logged_in_class}  ${saved_class} "
                          data-post_id="${hit.post_id}"
                          data-post_type="${hit.post_type}"
                          data-user_id="${user_id}"
                          data-saved="${saved}"
                          data-tooltip_favorites="${button_tooltip}"
                        >                        
                        <div class="tt-item__save_to_library_button" style=${saved  == '0' ? '' : 'display:none'}>
                            <button class="button cwk-details-button">
                              <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon__glyph ">
                                <path d="M15.1111 7.11111H8.88889V0.888889C8.88889 0.653141 8.79524 0.427048 8.62854 0.260349C8.46184 0.0936505 8.23575 0 8 0C7.76425 0 7.53816 0.0936505 7.37146 0.260349C7.20476 0.427048 7.11111 0.653141 7.11111 0.888889V7.11111H0.888889C0.653141 7.11111 0.427048 7.20476 0.260349 7.37146C0.0936505 7.53816 0 7.76425 0 8C0 8.23575 0.0936505 8.46184 0.260349 8.62854C0.427048 8.79524 0.653141 8.88889 0.888889 8.88889H7.11111V15.1111C7.11111 15.3469 7.20476 15.573 7.37146 15.7397C7.53816 15.9064 7.76425 16 8 16C8.23575 16 8.46184 15.9064 8.62854 15.7397C8.79524 15.573 8.88889 15.3469 8.88889 15.1111V8.88889H15.1111C15.3469 8.88889 15.573 8.79524 15.7397 8.62854C15.9064 8.46184 16 8.23575 16 8C16 7.76425 15.9064 7.53816 15.7397 7.37146C15.573 7.20476 15.3469 7.11111 15.1111 7.11111Z" fill="currentcolor"></path>
                              </svg>
                              <span class="favorite-button-text">${button_text}</span>
                            </button>                        
                        </div>
                        <div class="tt-item__remove_from_library_button" style=${saved  == '1' ? '' : 'display:none'}>
                          <button class="button cwk-details-button">
                            <svg width="1em" height="1em" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                              <path d="M15.1111 7.11121C3.20712 7.11121 12.7929 7.11121 0.888889 7.11121C0.653141 7.11121 0.427048 7.20486 0.260349 7.37156C0.0936505 7.53826 0 7.76435 0 8.0001C0 8.23584 0.0936505 8.46194 0.260349 8.62863C0.427048 8.79533 0.653141 8.88898 0.888889 8.88898C12.7929 8.88898 3.20712 8.88898 15.1111 8.88898C15.3469 8.88898 15.573 8.79533 15.7397 8.62863C15.9064 8.46194 16 8.23584 16 8.0001C16 7.76435 15.9064 7.53826 15.7397 7.37156C15.573 7.20486 15.3469 7.11121 15.1111 7.11121Z" fill="currentcolor"/>
                            </svg>
                            <span class="favorite-button-text">${button_text}</span>
                          </button>
                        </div>
                      </div>    
                      </div>
                    </div>
                  </div>  
              `
            }
          },
        }),

        pagination({
          container: '#pagination',
          cssClasses: {
            root: 'tgbl-is-pagination',
            list: [
              'tgbl-is-pagination-list',
              'tgbl-is-pagination-list--subclass',
            ],
            item: 'tgbl-is-pagination-item',
            firstPageItem: 'tgbl-is-first-page-item',
            lastPageItem: 'tgbl-is-last-page-item',
            previousPageItem: 'tgbl-is-previous-page-item',
            nextPageItem: 'tgbl-is-next-page-item',
            pageItem: 'tgbl-is-page-item',
            selectedItem: 'tgbl-is-selected-item',
            disabledItem: 'tgbl-is-disabled-item',
            link: 'tgbl-is-pagination-link',
          },
        }),
      ]) // END Search add widgets


      search.start()

      const router = instantSearchRouter.read()
      const searchPageState = router && router[INSTANT_SEARCH_INDEX_NAME] || {}

      // if we have status filters active set page to 1
      if(status_filters != undefined && status_filters.length){
        setInstantSearchUiState(searchPageState)
      }


      /***************
       AUTOCOMPLETE
       ****************/

      // Set the InstantSearch index UI state from external events.
      function setInstantSearchUiState(indexUiState) {

        search.setUiState(uiState => ({
          ...uiState,
          [INSTANT_SEARCH_INDEX_NAME]: {
            ...uiState[INSTANT_SEARCH_INDEX_NAME],
            // We reset the page when the search state changes.
            page: 1,
            ...indexUiState,
          },
        }))
      }

      if(!autocomplete_rendered){
        autocomplete_rendered=true
        autocomplete({
          container: '#tgbl-pe-algolia-autocomplete',
          //plugins: [querySuggestionsPlugin],
          //detachedMediaQuery: 'none',
          //detachedMediaQuery: '',
          //detachedMediaQuery: "(max-width: 680px)",
          placeholder: 'Search',
          openOnFocus: true,
          initialState: {
            query: searchPageState.query || '',
          },
          onSubmit({state}) {
            setInstantSearchUiState({
              query: state.query
            })
          },
          onReset() {
            setInstantSearchUiState({query: ''})
          },
          onStateChange({prevState, state}) {
            if (prevState.query !== state.query) {
              setInstantSearchUiState({query: state.query})
            }
            //console.log('333--- ', filters)
          },
          getSources({query}) {
            return [{
              sourceId: INSTANT_SEARCH_INDEX_NAME,
              getItems() {
                return getAlgoliaResults({
                  searchClient,
                  queries: [
                    {
                      indexName: INSTANT_SEARCH_INDEX_NAME,
                      query,
                      params: {
                        //filters:'course_users_enrolled:'+user_id,
                        //filters: filters,
                        //hitsPerPage: 5,
                        hitsPerPage: tgblCWKFrontend.max_suggestions,
                        attributesToRetrieve: ['post_title', 'content'],
                        attributesToSnippet: ['post_title:10', 'content:25'],
                        snippetEllipsisText: '…',
                      },
                    },
                  ],
                });
              },
              getItemInputValue({item}) {
                //console.log(item)
                return item.post_title
              },
              templates: {
                item({item, components, html}) {
                  return html`
                    <div class="aa-ItemWrapper">
                      <div class="aa-ItemContent">
  
                        <div class="aa-ItemContentBody">
                          <div class="aa-ItemContentTitle">
                            ${components.Highlight({
                    hit: item,
                    attribute: 'post_title',
                  })}
                          </div>
                          <div class="aa-ItemContentDescription">
                            ${components.Snippet({
                    hit: item,
                    //attribute: 'content',
                    attribute: 'content',
                  })}
                          </div>
                        </div>
                        <div class="aa-ItemActions">
                          <button
                            class="aa-ItemActionButton aa-DesktopOnly aa-ActiveOnly"
                            type="button"
                            title="Select"
                          >
                            <svg
                              viewBox="0 0 24 24"
                              width="20"
                              height="20"
                              fill="currentColor"
                            >
                              <path
                                d="M18.984 6.984h2.016v6h-15.188l3.609 3.609-1.406 1.406-6-6 6-6 1.406 1.406-3.609 3.609h13.172v-4.031z"
                              />
                            </svg>
                          </button>
                        </div>
                      </div>
                    </div>`;
                },
              },// end templates
            }]
          },

        }) // END AUTOCOMPLETE
      } // END if autocomplete rendered
    }, // END Algolia search function


    algoliaSearchFilters: function($_this, status_filters, user_id, is_admin) {

      /*
      // OLD FILTERS Logic TODO remove it eventually
      // course_users_not_started, course_users_in_progress, course_users_completed
      let status_filters = $_this.getStatusFilters($_this)

      let apply_status_filters = ''
      if(status_filters != undefined && status_filters.length){
        $.each(status_filters, function(k,v){
          let logic_operator = ''

          if(status_filters.length != k+1){
            logic_operator =' OR '
          }
          apply_status_filters += 'course_users_'+v+':'+user_id+logic_operator;
        })
      }
      let filters = apply_status_filters != '' ? 'course_users_enrolled:'+user_id+' AND ('+apply_status_filters+')' : 'course_users_enrolled:'+user_id
      if(is_admin) filters = apply_status_filters
      //console.log(filters)
      */

      // NEW FILTERS Logic
      // course_users_not_started, course_users_in_progress, course_users_completed, course_users_favorites
      //let status_filters = $_this.getStatusFilters($_this)

      let removeItem = 'favorites'

      //console.log('before ', status_filters)

      let favorites_filter = ''
      if($.inArray(removeItem, status_filters) !==-1) {
        status_filters.splice($.inArray(removeItem, status_filters), 1)
        favorites_filter = 'favorites'
      }

      let apply_status_filters = ''

      if(status_filters != undefined && status_filters.length){
        $.each(status_filters, function(k,v){

          let logic_operator = ''

          if(status_filters.length != k+1){
            logic_operator =' OR '
          }
          apply_status_filters += 'course_users_'+v+':'+user_id+logic_operator;
        })
      }

      if(favorites_filter == 'favorites'){
        if(apply_status_filters){
          apply_status_filters = '('+apply_status_filters+')' + ' AND course_users_'+favorites_filter+':'+user_id
        } else{
          apply_status_filters = 'course_users_'+favorites_filter+':'+user_id
        }
      }

      if(!is_admin){
        if(apply_status_filters){
          apply_status_filters = apply_status_filters +' AND course_users_enrolled:'+user_id
        } else{
          apply_status_filters = apply_status_filters + 'course_users_enrolled:'+user_id
        }
      }

      //console.log('222--- ', apply_status_filters)

      return apply_status_filters
    },


    toggleStatusVisibility:function($_this) {

      //const parent= $('.tgbl-instantsearch-container--js')
      const parent= $('.tgbl-instantsearch-container--js')
      const status_refinement= parent.find('#refinement-list-course-status')

      parent.on('click','#refinement-list-course-status input', function(){

        const router = instantSearchRouter.read()
        const uiState = router && router[INSTANT_SEARCH_INDEX_NAME] || {}

        //console.log(uiState)

        if(uiState && uiState.sortBy != undefined) {
          const s_index = instantSearchRouter.read()[INSTANT_SEARCH_INDEX_NAME].sortBy
          $_this.algoliaSearch($_this,s_index)
        } else{
          $_this.algoliaSearch($_this)
        }

        //console.log( 's_index', s_index )
      })
    },


    resetStatusFilters:function($_this) {
      const parent= $('.tgbl-instantsearch-container--js')
      const status_refinement= parent.find('#refinement-list-course-status')

      status_refinement.find('input').each(function(){
        const parent_li = $(this).parents('li')  //tgbl-refinement-list-selected-item
        if($(this).is(':checked')){
          $(this).prop(':checked',false)
          //$(this).parents('li.tgbl-refinement-list-item').removeClass('tgbl-refinement-list-selected-item')
          $(this).trigger('click')
          //console.log($(this).attr("checked"), $(this).prop(":checked"))
          parent_li.removeClass('tgbl-refinement-list-selected-item')
        }
      })
    },


    getStatusFilters:function($_this) {
      const parent= $('.tgbl-instantsearch-container--js')
      const status_refinement= parent.find('#refinement-list-course-status')
      let status_filters = []

      status_refinement.find('input').each(function(){
        const parent_li = $(this).parents('li')  //tgbl-refinement-list-selected-item
        if($(this).is(':checked')){
          status_filters.push($(this).val())
          parent_li.addClass('tgbl-refinement-list-selected-item')

        } else{
          parent_li.removeClass('tgbl-refinement-list-selected-item')
        }
      })
      return status_filters
    },


    switchGridTableButton:function() {

      const parent= $('.tgbl-pe-algolia-autocomplete-wrap--js')
      const switch_grid_button = parent.find('.grid-table-icon--js')

      switch_grid_button.on('click', function(e){

        const $this= $(this)
        const list_parent= parent.parents('.tgbl-instantsearch-container--js').find('.archive-layouts--js')

        if(!$this.hasClass('active-view--js')){
          parent.find('.grid-table-icon--js.active-view--js').removeClass('active-view--js')
          $this.addClass('active-view--js')
        }

        if($this.hasClass('table-view--js')){
          list_parent.addClass('archive-layout-table')
        } else{
          list_parent.removeClass('archive-layout-table')
        }
      })
    },


    onPopstateCorrection: function($_this, search_index) {

      const autocompletebox = $('.tgbl-pe-algolia-autocomplete-wrap--js').find('input')

      // Correct autocompletebox value on browser history button click
      $(window).on('popstate', function(event) {
        if(instantSearchRouter.read()[search_index] != undefined && instantSearchRouter.read()[search_index].query != undefined) {
          autocompletebox.val(instantSearchRouter.read()[INSTANT_SEARCH_INDEX_NAME].query)
        } else{
          autocompletebox.val('')
        }
        //console.log(autocompletebox.val())
      })
    },
  }
}

export { AlgoliaInstantSearch }

